import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCornSeeds extends Item {
    constructor() {
        super(definitions.ITEM_ID.CORN_SEEDS, texture("prop_corn_seeds_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}